import { KeyboardArrowDown } from "@mui/icons-material";
import { Button, CircularProgress, Dialog, InputBase, MenuItem, Select } from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const ChannelAddedModal = ({ open, setOpen , code, setChannels }) => {
    const [step, setStep] = useState(1)
    const [error_msg, setErrormsg ] = useState(null)
    const navigate = useNavigate() 

    const getToken = async(channel_id) => {
         try {
console.log('hi')
            let token = await axios.post(
                process.env.REACT_APP_BACKEND_URL + "slack/get-access-token", {
                    code, clientId:'8216119482166.8222742235810', 
                }
                
              );

              console.log('token',token)


              
                        let channel_data = await axios.post(
                          process.env.REACT_APP_BACKEND_URL + "update-channel",  {
                            channel_id:  channel_id,
                            incoming_webhook_url: token.data.incoming_webhook.url,
                              status: 'active',
                              value: token.data.incoming_webhook.channel,
                              organization_id: JSON.parse(localStorage.getItem("organization"))
                                .orgId.S,
                              slack_id: token.data.access_token,
                            }
                          
                        );
                  
                        console.log(channel_data);
                      
                       
                  
                        localStorage.setItem(
                          "organization",
                          JSON.stringify(channel_data.data.updatedItem)
                        );
                  
                        setChannels(channel_data.data.updatedItem.channels.L)

                        setStep(2) 
                        setTimeout(() => {
                            navigate('/dashboard/channels')
                        }, 3000);
         } catch (error) {
            if (error.response && error.response.data) {
                console.error("Response data:", error.response.data);
                setErrormsg(error.response.data.error);
                setStep(3)
              }
         }
            
    }

    useEffect(()=> {
        

        if(code){
            const queryParams = new URLSearchParams(window.location.search);
            const state = queryParams.get("state");
        
            // Extract channel_id from state if it exists
            if (state && state.startsWith("channel_id:")) {
              const extractedChannelId = state.split(":")[1];
              console.log('channel_id', extractedChannelId)
              getToken(extractedChannelId)
            }

        }

    },[code])
  return (
    <Dialog open={open} fullWidth={true} maxWidth={"sm"}
    
    
    BackdropProps={{
          style: { backgroundColor: "rgba(0, 0, 0, 0.2)" }, // Adjust opacity here
        }}
    >
      {!code ? (
        <div className="lg:px-8 px-4 py-14">
        <div className="lg:text-[20px] text-[#030229]  text-[15px] font-semibold  text-center mb-4">Channel Added!</div>


      <div className="flex justify-center">
      <img src='/icons/user_hand.png' className="w-[100px]"/>
      </div>


        



        <div className="flex items-center justify-center space-x-3 mt-4">
        <Button
                  sx={{
                    textTransform: "none",
                    bgcolor:'rgba(96,91,255,1)',
                    color: "white",
                    py: "6px",
                    px: "30px",
                    borderRadius: "7px",
                    border:'1.5px solid rgba(96,91,255,0.1)',
                    fontSize: { lg: "14px", xs: "13px" },
                    width: "fit",
                  }}
                  onClick={()=> {
                    
                    setOpen(false)
                  }}
                >
                  Okay
                </Button>
                
        </div>


      
      </div>
      ): (
        <div className="lg:px-8 px-4 py-14">
       

        {step === 1 && (
          <>
             <div className="lg:text-[20px] text-[#030229]  text-[15px] font-semibold  text-center mb-4">Loading</div>

<div className="flex justify-center pb-4">
<CircularProgress size='3rem' thickness={5} sx={{ color:'#605BFF'}}/>
</div>
</>
      )}

      {step === 2 && (
          <>
           <div className="lg:text-[20px] text-[#030229]  text-[15px] font-semibold  text-center mb-4">Channel Added!</div>

<div className="flex justify-center">
<img src='/icons/user_hand.png' className="w-[100px]"/>
</div>
</>
      )}

{step === 3 && (
          <>
           <div className="lg:text-[20px] text-[#030229]  text-[15px] font-semibold  text-center mb-4">Error</div>

<div className="flex justify-center text-[14px]">
{error_msg}
</div>
</>
      )}


        



        <div className="flex items-center justify-center space-x-3 mt-4">
        <Button
                  sx={{
                    textTransform: "none",
                    bgcolor:'rgba(96,91,255,1)',
                    color: "white",
                    py: "6px",
                    px: "30px",
                    borderRadius: "7px",
                    border:'1.5px solid rgba(96,91,255,0.1)',
                    fontSize: { lg: "14px", xs: "13px" },
                    width: "fit",
                  }}
                  onClick={()=> {
                    
                    setOpen(false)
                    navigate('/dashboard/channels')
                  }}
                >
                  Okay
                </Button>
                
        </div>


      
      </div>
      )}
    </Dialog>
  );
};

export default ChannelAddedModal;
